import React from 'react';
import { useDispatch } from 'react-redux';
import Immutable from 'immutable';

import { CoreLink } from '@uncinc/react-drupal-core';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { bytesToSize } from '../../../helpers';

import './style.scss';

import { trackEvent } from '../../../actions/UI';

const Downloads = ({ entity }) => {

  const title = entity.getIn(['field_title', 0, 'value']);
  const dispatch = useDispatch();

  return (
    <Container className="Downloads" small>
      <div className="row">
        <div className="col-12">

          <div className="Downloads__inner">
            {title && (
              <h3 className="Downloads__title">
                {title}
              </h3>
            )}

            {entity.get('field_media_items', Immutable.List()).size ? (
              <ul className="Downloads__list">
                {entity.get('field_media_items').map((item) => {
                  const fileSize = item.get('file_size', 0);
                  const filesizeLabel = fileSize ? bytesToSize(fileSize) : '';
                  const fileSource = item.get('source');

                  // Files can be removed from media items
                  if (!fileSource) {
                    return;
                  }

                  const type = fileSource.substring(fileSource.lastIndexOf('.') + 1);
                  const fileTitle = item.get('title');

                  const onCtaClick = () => {
                    dispatch(trackEvent('Download', 'Een bestand gedownload', fileTitle, fileTitle));
                  };

                  return (
                    <li className="Downloads__item" key={item.get('target_uuid')}>
                      <div className="Downloads__item__icon icon-before icon-download icon-variant-4" />
                      <div className="Downloads__item__content">
                        <CoreLink target="_blank" onClick={onCtaClick} to={fileSource} title={fileTitle} /><br />
                        <div className="Downloads__item__metadata">
                          <div className="Downloads__item__metadata__filetype">{type}</div>
                          <div className="Downloads__item__metadata__filesize">{filesizeLabel}</div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : null}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Downloads;
